/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ParticipantRole = {
    Agent: 'Agent',
    Customer: 'Customer'
} as const;
export type ParticipantRole = typeof ParticipantRole[keyof typeof ParticipantRole];


export function ParticipantRoleFromJSON(json: any): ParticipantRole {
    return ParticipantRoleFromJSONTyped(json, false);
}

export function ParticipantRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantRole {
    return json as ParticipantRole;
}

export function ParticipantRoleToJSON(value?: ParticipantRole | null): any {
    return value as any;
}

